import { defineRouting } from 'next-intl/routing';

/**
 * Fuente de verdad única para la configuración de localización.
 * Importar este objeto en proxy.js, i18n/request.js, y cualquier
 * helper de navegación para evitar duplicaciones.
 *
 * Locales soportados: 15 idiomas (fuente de verdad: LanguageSelector + routing)
 */
export const routing = defineRouting({
  locales: ['es', 'en', 'pt', 'fr', 'de', 'nl', 'it', 'ru', 'zh', 'ja', 'ko', 'ar', 'hi', 'tr', 'pl'],
  defaultLocale: 'es',
  localePrefix: 'always',
});



